var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgABadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    vectorEffect: "non-scaling-stroke",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.15,40.89l-1.6,-8.25l-0.06,0l-1.6,8.25l3.26,0zm-8.06,7.97l5.09,-22.78l2.72,0l5.08,22.78l-3.26,0l-0.96,-4.9l-4.45,0l-0.96,4.9l-3.26,0z",
    fill: "currentColor",
    id: "text1-4",
    stroke: "currentColor",
    strokeWidth: 0.5,
    transform: "scale(1.0406967,0.96089475)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m36.45,32.9l-3.2,-16.51l-0.13,0l-3.2,16.51l6.53,0zm-11.75,-5.4l5.79,-24.23l5.44,0l10.18,45.56l-6.53,0l-1.92,-9.79l-8.89,0l-0.72,3.55l-3.35,-15.09z",
    fill: "none",
    fillOpacity: 0,
    id: "text1",
    stroke: "currentColor",
    transform: "scale(1.0406967,0.96089475)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m22.17,36.89l-2.4,-12.38l-0.09,0l-2.4,12.38l4.89,0zm-10.89,7.53l6.43,-29.75l4.08,0l7.63,34.17l-4.9,0l-1.44,-7.34l-6.67,0l-1.44,6.56l-3.69,-3.64z",
    fill: "none",
    fillOpacity: 0,
    id: "text1-9",
    stroke: "currentColor",
    transform: "scale(1.0406967,0.96089475)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgABadge);
export default __webpack_public_path__ + "static/media/A_Badge.88308e27c29e2f4bd45967356b465e70.svg";
export { ForwardRef as ReactComponent };